<!-- eslint-disable vue/valid-v-model -->
<template>
  <div class="feedback-container">
    <div class="content" ref="table">
      <div class="tools clearfix">
        <div class="left">
          <el-input
            v-model="searchInfo.phoneNum"
            placeholder="输入手机号"
            style="width: 210px; display: inline-block; margin-left: 10px"
          ></el-input>
          <el-input
            v-model="searchInfo.nickName"
            placeholder="输入昵称"
            style="width: 210px; display: inline-block; margin-left: 10px"
          ></el-input>
          <el-button type="primary" style="margin-left: 16px" @click="search"
            >搜索</el-button
          >
        </div>

        <div class="right">
          <el-button
            type="primary"
            style="margin-left: 16px"
            icon="el-icon-plus"
            @click="showForm(0, 'add')"
            v-hasPermi="['客户管理', '新增']"
            >新增</el-button
          >
          <!--  <el-button
                type="primary"
                style="margin-left: 16px"
                @click="toggleSelection()"
                v-hasPermi="['用户反馈', '批量选择']"
                >批量选择</el-button
              >
              <el-button
                type="danger"
                style="margin-left: 16px"
                :disabled="multipleSelection.length === 0"
                @click="deleteSelection()"
                v-hasPermi="['用户反馈', '删除']"
                >删除</el-button
              > -->
        </div>
      </div>
      <el-table
        stripe
        :data="table.data"
        v-loading="loading"
        :height="table.height"
        :header-cell-style="{ background: '#eaeef6' }"
        ref="multipleTable"
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
        <el-table-column type="index" label="序号" align="center">
        </el-table-column>
        <el-table-column
          prop="phoneNum"
          width="200"
          label="手机号"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="nickName"
          width="300"
          label="昵称"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="openid"
          width="300"
          label="微信OpenId"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="bindCarText" label="绑定车辆" align="center">
        </el-table-column>
        <el-table-column label="操作" width="170" align="center">
          <template slot-scope="scope">
            <div class="edit">
              <span
                class="btn read"
                v-hasPermi="['客户管理', '详情']"
                @click="showForm(scope.row.id, 'detail')"
                >查看</span
              >
              <span
                class="btn read"
                v-hasPermi="['客户管理', '编辑']"
                @click="showForm(scope.row.id, 'edit')"
                >编辑</span
              >
              <span
                class="btn read"
                @click="deleteClick(scope.row.id)"
                v-hasPermi="['客户管理', '删除']"
                >删除</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="sizes,prev, pager, next"
          :current-page.sync="table.page"
          :page-size="table.pageSize"
          :total="table.total"
          @current-change="currentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
    </div>
    <FormInfo
      ref="formInfoRef"
      :type="formType"
      :id="id"
      :visible="formDialogVisible"
      @visible-change="modalVisibleChange"
      @success="refresh()"
    ></FormInfo>
  </div>
</template>

<script>
import { MessageBox } from 'element-ui';
import { getAppUser, deleteAppUser } from '@/api/customer';
import FormInfo from './add';

export default {
  components: {
    FormInfo,
  },
  data() {
    return {
      id: null,
      formType: '',
      formDialogVisible: false,
      currentNodeKey: 0, //当前选中的点
      loading: false,
      table: {
        data: [],
        height: 100,
        page: 1,
        pageSize: 50,
        total: 0,
      },
      multipleSelection: [],
      searchInfo: {
        nickName: '',
        phoneNum: '',
      },
    };
  },
  created() {
    this.getData();
  },
  mounted() {
    this.$nextTick(() => {
      this.table.height = window.innerHeight - this.$refs.table.offsetTop - 170;
      window.onresize = () => {
        this.table.height =
          window.innerHeight - this.$refs.table.offsetTop - 170;
      };
    });
  },
  methods: {
    modalVisibleChange(val) {
      this.formDialogVisible = val;
    },
    // 弹窗
    showForm(id, type) {
      this.formDialogVisible = true;
      this.formType = type;
      this.id = id;
    },

    getData() {
      const params = {
        ...this.searchInfo,
        page: this.table.page,
        pageSize: this.table.pageSize,
      };
      getAppUser(params).then((da) => {
        da.data.content.forEach((element) => {
          if (element.bindCardList && element.bindCardList.length > 0) {
            const bindCardArray =
              element.bindCardList.map((item) => {
                return item.frameNum;
              }) || [];
            if (bindCardArray.length > 2) {
              const newArray = bindCardArray.slice(0, 2);
              element.bindCarText =
                newArray.join('、') + '等' + bindCardArray.length + '辆';
            } else {
              element.bindCarText = bindCardArray.join('、');
            }
          }
        });
        this.table.data = da.data.content;
        this.table.total = da.data.total;
      });
    },
    toggleSelection() {
      // this.table.data.forEach(row => {
      if (this.multipleSelection.length === this.table.total) {
        return;
      } else {
        this.$refs.multipleTable.toggleAllSelection();
        this.multipleSelection = this.table;
      }
      // });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    search() {
      this.table.page = 1;
      this.getData();
    },
    currentChange() {
      this.getData();
    },
    handleSizeChange(e) {
      this.table.page = 1;
      this.table.pageSize = e;
      this.getData();
    },
    deleteClick(id) {
      MessageBox.confirm('此操作将删除该信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteAppUser(id).then((res) => {
          if (res.code == 0) {
            this.$message.success('删除成功!');
            this.refresh();
          }
        });
      });
    },

    // deleteSelection() {
    //   MessageBox.confirm('确认删除?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning',
    //   }).then(() => {
    //     let params = [];
    //     this.multipleSelection.map((item) => {
    //       params.push(item.id);
    //     });
    //     delFeedBack({ ids: params.join(',') }).then((res) => {
    //       if (res.code == 0) {
    //         this.$message.success('删除成功!');
    //         this.refresh();
    //       }
    //     });
    //   });
    // },
    refresh() {
      this.getData();
    },
  },
};
</script>

<style lang="less" scoped>
.feedback-container {
  display: flex;
  //   flex-direction: column;
  justify-content: space-between;
  //   width: 100%;
  //   height: 100%;
  gap: 0 32px;
  margin: 20px;
  background: #fff;
  box-shadow: 0 0 6px 1px #acacac;

  .content {
    flex: 1;
    min-height: 0;
    border-left: 1px solid #f1f1f1;
    padding: 20px;

    .tools {
      padding-bottom: 20px;
      .left {
        float: left;
        input {
        }
      }
      .right {
        float: right;
      }
    }
    .edit {
      .btn {
        color: #3992de;
        cursor: pointer;
        & + .btn {
          margin-left: 24px;
        }
      }
    }
    .status-icon {
      position: relative;
      top: 2px;
      display: inline-block;
      width: 14px;
      height: 14px;
      border-radius: 100%;
      background: #ff4200;
      &.green {
        background: #00ff00;
      }
    }
    .pagination {
      text-align: center;
      padding-top: 20px;
    }
  }
}
</style>
<style lang="less">
.feedback-container {
  .el-table {
    .gutter {
      background: #eaeef6;
    }
  }
}
</style>
